export enum FilterTypeVisibility {
  Both = 0,
  Filter_Header_Only = 1,
  Card_Modal_Only = 2,
  None = 4,
}
